import { createModalRouter as a } from "../../router.js";
import p from "./ApiClientModal.vue.js";
import { createApiClient as i } from "../../libs/create-client.js";
const y = async ({
  el: l = null,
  configuration: e = {},
  mountOnInitialize: r = !0,
  store: t
}) => {
  const n = {
    ...e
  }, o = i({
    el: l,
    appComponent: p,
    configuration: n,
    persistData: !1,
    isReadOnly: !0,
    store: t,
    mountOnInitialize: r,
    router: a(),
    layout: "modal"
  }), { importSpecFile: s, importSpecFromUrl: u } = o.store;
  return t || (e.url ? await u(e.url, "default", {
    proxyUrl: e.proxyUrl,
    useCollectionSecurity: !0,
    ...e
  }) : e.content && await s(e.content, "default", {
    useCollectionSecurity: !0,
    ...e
  })), o;
}, C = ({
  el: l = null,
  configuration: e = {},
  mountOnInitialize: r = !0,
  store: t
}) => i({
  el: l,
  appComponent: p,
  configuration: e,
  persistData: !1,
  isReadOnly: !0,
  mountOnInitialize: r,
  store: t,
  router: a(),
  layout: "modal"
});
export {
  y as createApiClientModal,
  C as createApiClientModalSync
};
